import { useLocalSearchParams, Href } from 'expo-router';

import { ROUTES } from '@/constants/routes';

export function useReferralNavigation() {
  const { referred_by: referredBy } = useLocalSearchParams<{ referred_by?: string }>();

  const getNavigationPath = (path: string) => {
    if (!referredBy) {
      return path as Href;
    }

    const separator = path.includes('?') ? '&' : '?';

    return `${path}${separator}referred_by=${encodeURIComponent(referredBy)}` as Href;
  };

  const getDefaultRoute = () => {
    return referredBy ? ROUTES.DIRECTORY : ROUTES.LOGIN;
  };

  return {
    getNavigationPath,
    getDefaultRoute,
  };
}
